import { render, staticRenderFns } from "./FeedbackStatus.vue?vue&type=template&id=52e5834e&scoped=true&"
import script from "./FeedbackStatus.vue?vue&type=script&lang=ts&"
export * from "./FeedbackStatus.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackStatus.vue?vue&type=style&index=0&id=52e5834e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5834e",
  null
  
)

export default component.exports